import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';

import en from 'vuetify/es5/locale/en.js';
import ro from 'vuetify/es5/locale/ro.js';

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { en, ro },
    current: 'ro'
  }
});
